import { SearchIcon, WarningIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Grid,
  GridItem,
  HStack,
  IconButton,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  SimpleGrid,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { BiUser } from "react-icons/bi";
import { MdExitToApp } from "react-icons/md";
import { HiOutlineClipboardList } from "react-icons/hi";
import BUP from "../../assets/logo/bup-wakil.png";

import Pemda from "../../assets/logo/pemda-karangasem.png";
import BPD from "../../assets/logo/bank-bpd.png";
import IPOS from "../../assets/logo/ipos.png";

export default function Navbar() {
  const username = localStorage.getItem("username");
  const { keyword } = useParams();
  const [mobile] = useMediaQuery("(max-width: 600px)");

  const [company, setCompany] = useState("");
  useEffect(() => {
    if (keyword !== undefined) {
      setCompany(keyword);
    }
  }, [keyword]);

  console.log(mobile);

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      window.location.replace("/" + company);
    }
  };
  const handleChange = (e) => {
    const { value } = e.target;
    setCompany(value);
  };
  const handleButtonSearch = () => {
    window.location.replace("/" + company);
  };

  return (
    <div>
      <Grid
        templateColumns="repeat(3, 1fr)"
        bgColor="#2563EB"
        color="white"
        px="10"
        display="flex"
        hidden={mobile}
        alignItems="center"
      >
        <GridItem colSpan={2} display="flex" width="full">
          <Box px="5">
            <Link to="/">
              <SimpleGrid columns={4} py="8" align="center">
                <Image src={Pemda} alt="Logo Pemda Karangasem" h="10" />
                <Image src={BPD} alt="Logo Pemda Karangasem" h="10" />
                <Image src={IPOS} alt="Logo Pemda Karangasem" h="10" w="full" />
                <Box display="flex" justifyContent="flex-end">
                  <Image
                    display="flex"
                    justifyContent="flex-end"
                    src={BUP}
                    alt="Logo Pemda Karangasem"
                    h="10"
                  />
                </Box>
              </SimpleGrid>
            </Link>
          </Box>
          <Box mt="8" px="5" w="full">
            <InputGroup>
              <Input
                _placeholder={{ color: "white" }}
                placeholder="Cari Perusahaan"
                value={company}
                onKeyDown={handleEnter}
                onChange={handleChange}
              />
              <InputRightElement
                children={
                  <IconButton
                    onClick={handleButtonSearch}
                    bgColor="transparent"
                  >
                    <SearchIcon />
                  </IconButton>
                }
              />
            </InputGroup>
          </Box>
        </GridItem>
        <GridItem display="flex" justifyContent="flex-end">
          <HStack spacing="3">
            <Link to="/" reloadDocument>
              Beranda
            </Link>
            {username && (
              <>
                <Link to="/keranjang">
                  <Box display="flex" alignItems="center">
                    Keranjang
                    <AiOutlineShoppingCart
                      size={20}
                      style={{ marginLeft: "10px" }}
                    />
                  </Box>
                </Link>
                <Link to="/daftar-transaksi">
                  <Box display="flex" alignItems="center">
                    <Text whiteSpace="nowrap">Pesanan Saya</Text>
                    <HiOutlineClipboardList size="30" />
                  </Box>
                </Link>
              </>
            )}
          </HStack>
          <Box border="1px" my="1" mx="5"></Box>
          {username ? (
            <Menu>
              <MenuButton
                as={Button}
                color="white"
                bgColor="#2563EB"
                border="1px solid white"
              >
                {username}
              </MenuButton>
              <MenuList bgColor="#2563EB">
                <Link to="/akun">
                  <MenuItem>
                    <Box display="flex">
                      <BiUser />
                      <Text px="2">Profile</Text>
                    </Box>
                  </MenuItem>
                </Link>
                <MenuItem
                  onClick={() => {
                    localStorage.removeItem("username");
                    localStorage.removeItem("access_token");
                    localStorage.removeItem("refresh_token");
                    localStorage.removeItem("multi_product");
                    window.location.replace("/");
                  }}
                >
                  <MdExitToApp />
                  <Text px="2">Logout</Text>
                </MenuItem>
              </MenuList>
            </Menu>
          ) : (
            <Link to="/login">
              <Button variant="outline">Masuk </Button>
            </Link>
          )}
        </GridItem>
      </Grid>
      <Box hidden={!mobile} display="flex" p="3" bgColor="#2563EB">
        <InputGroup bgColor="white" borderRadius="5px">
          <Input
            _placeholder={{ color: "gray" }}
            placeholder="Cari Perusahaan"
            value={company}
            onKeyDown={handleEnter}
            onChange={handleChange}
          />
          <InputLeftElement
            children={
              <IconButton onClick={handleButtonSearch} bgColor="transparent">
                <SearchIcon />
              </IconButton>
            }
          />
        </InputGroup>
        <Link to="/keranjang">
          <IconButton variant="ghost" ml="3" color="white">
            <AiOutlineShoppingCart size={20} />
          </IconButton>
        </Link>
      </Box>
    </div>
  );
}
